import { AccordionTemplate } from "themes/common/components";

function Accordion(props) {
    return <AccordionTemplate {...props} />;
}

export default Accordion;
